import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {SelectorModel} from '@shared/models/selector.model';
import {BehaviorSubject, of} from 'rxjs';
import {QuickSelectionModelId, TreeItemNode} from '@shared/models/tree-selector.models';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-apply-hallmark-tagging-dialog',
  templateUrl: './apply-hallmark-tagging-dialog.component.html',
  styleUrls: ['./apply-hallmark-tagging-dialog.component.scss']
})
export class ApplyHallmarkTaggingDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  hallmarkKeywordList: any[] = [];
  selectedTags: string[] = [];

  selectorList: SelectorModel[];
  selectorNodes: any[];
  selectorNodes$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);

  @Output() selectionChanged: EventEmitter<any> = new EventEmitter();

  constructor(private dac6RepoterApiService: Dac6ReporterApiService) { }

  ngOnInit() {
    this.selectedTags = this.data.input.selectedTags;
    this.dac6RepoterApiService.getAllHallmarkAutoTags().subscribe(res => {
      res.forEach(h => {
        this.hallmarkKeywordList = this.hallmarkKeywordList.concat(h.keywords);
        this.hallmarkKeywordList = this.hallmarkKeywordList.concat(h.selectedTags);
      });
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      this.hallmarkKeywordList = this.hallmarkKeywordList.filter(unique);
      this.createTreeSelector(this.hallmarkKeywordList);
    });
  }

  createTreeSelector(hallmarkKeywordList: any[]) {
    if (hallmarkKeywordList) {
      this.hallmarkKeywordList = hallmarkKeywordList.map(h => {
        return {
          key: h,
          isChecked: this.selectedTags.includes(h)
        };
      });
      this.selectorCreate();
      this.selectorList.forEach((selector: SelectorModel) => {
        this.synWithSavedSelection(selector);
        this.selectorNodes = this.buildSelectorTree(selector, 0);
        selector.selectorData$ = new BehaviorSubject([]);
        selector.selectorData$.next(this.selectorNodes);
        selector.isParentNodeCollapsible$ = new BehaviorSubject(true);
      });
    }
  }

  selectorCreate() {
    this.selectorList = <SelectorModel[]>[
      {
        selectorTitle: 'Tags',
        displayKey: 'key',
        items: this.hallmarkKeywordList,
        isRadioSelector: false
      }
    ];
  }

  private synWithSavedSelection (selector: SelectorModel) {
    if (!selector.isRadioSelector) {
      selector.selectorQuickSelections$ = of([
        {
          name: 'All ' + selector.selectorTitle,
          id  : QuickSelectionModelId.ALL
        },
        {
          name: 'None',
          id  : QuickSelectionModelId.NONE
        }
      ]);
    } else {
      selector.selectedItem = selector.items.find(item => item.isChecked);
    }
  }

  buildSelectorTree (selector: SelectorModel, level: number) {
    const data: TreeItemNode[] = [];
    selector.items.forEach(item => {
      const node = new TreeItemNode();
      node.item = {};
      node.item.value = item;
      node.item.title = item[selector.displayKey];
      node.item.id = item.id;
      node.item.isChecked = item.isChecked;
      node.item.isDisabled = false;
      data.push(node);
    });
    return data;
  }

  onSelectionChange (event, selector: SelectorModel) {
    if (selector.isRadioSelector) {
      selector.selectedItem = event.currentTreeNode.item;
    }
    this.selectionChanged.emit(event.selectedTreeNodes.filter(o => o.item.isChecked === true).map(o => o.item));
  }

  onOkClicked(): boolean {
    this.data.input.selectedTags = this.selectorNodes.filter(o => o.item.isChecked === true).map(o => o.item.title);
    return true;
  }

}
